var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "withdraw-operation-manual" }, [
    _c("h2", { staticClass: "title" }, [
      _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.title")))]),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips1")))]),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/1.png"),
          },
        }),
      ]),
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips2")))]),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips3"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips4"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips5"))),
        ]),
      ]),
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips6")))]),
        ]),
        _c(
          "p",
          { staticClass: "sub-title", staticStyle: { "padding-top": "20px" } },
          [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips7")))]
        ),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips8"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/2.png"),
          },
        }),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips9"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/3.png"),
          },
        }),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips10"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips11"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips12"))),
        ]),
        _vm._m(0),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips13"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips14"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/6.png"),
          },
        }),
        _c(
          "p",
          { staticClass: "sub-title", staticStyle: { "padding-top": "20px" } },
          [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips15")))]
        ),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips16"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips17"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips18"))),
        ]),
      ]),
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips19")))]),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips20"))),
        ]),
      ]),
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips21")))]),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips22"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips23"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/7.png"),
          },
        }),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/8.png"),
          },
        }),
      ]),
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips24")))]),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips25"))),
        ]),
        _c("p", { staticClass: "sub-title" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips26"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips27"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/9.png"),
          },
        }),
      ]),
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips28")))]),
        ]),
        _c("p", { staticClass: "sub-title" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips29"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips30"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/10.png"),
          },
        }),
        _c("p", { staticClass: "sub-title" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips31"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips32"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/11.png"),
          },
        }),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/12.png"),
          },
        }),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips33"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/13.png"),
          },
        }),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/14.png"),
          },
        }),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips34"))),
        ]),
        _c("img", {
          attrs: {
            src: require("../../../static/imgs/WthdrawOperationManual/doc/15.png"),
          },
        }),
      ]),
      _c("div", { staticClass: "step-wrap" }, [
        _c("p", { staticClass: "step-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips35")))]),
        ]),
        _c("p", { staticClass: "sub-title" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips36"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips37"))),
        ]),
        _c("p", { staticClass: "sub-title" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips38"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips39"))),
        ]),
        _c("p", { staticClass: "sub-title" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips40"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips41"))),
        ]),
        _c("p", { staticClass: "sub-title" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips42"))),
        ]),
        _c("p", { staticClass: "step-desc" }, [
          _vm._v(_vm._s(_vm.$t("components.wthdrawManual.tips43"))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: require("../../../static/imgs/WthdrawOperationManual/doc/4.png"),
        },
      }),
      _c("img", {
        attrs: {
          src: require("../../../static/imgs/WthdrawOperationManual/doc/5.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }